import { ELocale } from '../../../i18n/localeEnum';

export const localeEnumToRegionUuid: Partial<Record<ELocale, number>> = {
  [ELocale.EN_US]: 477,
  [ELocale.EN_GB]: 476,
  [ELocale.FR_FR]: 240,
  [ELocale.IT_IT]: 233,
  [ELocale.DE_DE]: 214,
  [ELocale.NN_NO]: 209,
  [ELocale.SV_SE]: 190,
  [ELocale.ES_ES]: 229,
  [ELocale.NL_NL]: 1218,
  [ELocale.CS_CZ]: 224,
  [ELocale.PL_PL]: 241,
  [ELocale.SK_SK]: 235,
};

export default localeEnumToRegionUuid;
